import { InnerBlocks } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

const PageHeader = {
  title: __('Page header'),
  description: __('Page header block for the ABS theme'),
  icon: 'editor-textcolor',
  attributes: {},
  edit({ className }) {

    const ALLOWED_BLOCKS = [ 'core/paragraph', 'core/button' ];
    const MY_TEMPLATE = [
      [ 'core/paragraph', { placeholder: __('Insert byline') } ],
      [ 'core/button', { placeholder: __('Insert call to action'), align: 'center' } ]
    ];

    return (
        <div className={className}>
          <div className="container">
            <InnerBlocks
              template={ MY_TEMPLATE }
              templateLock={ false }
              allowedBlocks={ ALLOWED_BLOCKS }
            />
          </div>
        </div>
    );
  },

  save({ className }) {
    return (
      <div className={className}>
        <div className="container">
          <InnerBlocks.Content />
        </div>
      </div>
    );
  },
};

export default PageHeader;
